import { ColumnsType, EditIcon } from '@/components/_common';
import {
  InvoiceColumns,
  InvoiceDTO,
  InvoiceSituationColor,
} from '@/core/domain/invoice/invoice/Invoice.types';
import { COLUMNS_WIDTH, getTableScrollX } from '@/utils/table';
import { Modal, ModalProps, Table } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import StatusTag from '../StatusTag';
import { useIntl } from 'react-intl';
import { InvoiceSituation } from '@/core/domain/invoice/invoices/invoices.enums';
import moment from 'moment';
import useInvoiceFilesColumn from '../useInvoiceFilesColumn';

interface Props extends ModalProps {
  invoices?: InvoiceDTO[];
}

const ReferencedNotesModal = ({ open, onCancel, invoices }: Props) => {
  const intl = useIntl().formatMessage;

  const columns: ColumnsType<InvoiceColumns> = [
    {
      dataIndex: 'number',
      title: intl({ id: 'invoice.column.table.invoiceNumber' }),
      render: (value) => value || '-',
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    {
      dataIndex: 'serie',
      title: intl({ id: 'invoice.column.table.series' }),
      render: (value) => value || '-',
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    {
      dataIndex: 'emissionDate',
      title: intl({ id: 'invoice.column.table.issuanceDate' }),
      render: (value) => (value ? moment(value).format('DD/MM/YYYY') : '-'),
      width: COLUMNS_WIDTH.date,
      ellipsis: true,
    },
    {
      dataIndex: 'customerName',
      title: 'Destinatário',
      width: COLUMNS_WIDTH.default,
      render: (_, row) => {
        if (row.customerName) return row.customerName;
        if (row.supplierName) return row.supplierName;
        if (row.insurerName) return row.insurerName;
        return '-';
      },
      ellipsis: true,
    },
    {
      dataIndex: 'invoiceType',
      title: 'Tipo',
      width: COLUMNS_WIDTH.default,
    },
    {
      dataIndex: 'situation',
      title: intl({ id: 'invoice.column.table.situation' }),

      render: (value: InvoiceSituation) => {
        if (value) {
          return (
            <StatusTag
              color={InvoiceSituationColor[value]}
              label={intl({ id: `invoice.situation.${value}` })}
            />
          );
        }
        return '-';
      },
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    ...useInvoiceFilesColumn(),
    {
      title: 'Ações',
      width: 50,
      align: 'right',
      fixed: 'right',
      render: (_, item) => (
        <Link
          to={`/app/fiscal/invoice/${item.invoiceType}/${item.id}/datas`}
          target="_blank"
        >
          <EditIcon />
        </Link>
      ),
    },
  ];
  return (
    <Modal
      title="Notas Referenciadas"
      open={open}
      onCancel={onCancel}
      width={'80%'}
      footer={false}
    >
      <Table
        dataSource={invoices}
        columns={columns}
        pagination={false}
        scroll={{ x: getTableScrollX(columns) }}
      />
    </Modal>
  );
};

export default ReferencedNotesModal;
